import { Card, Row, Col, Button, Space, Alert } from "antd";
import { NationalityInfo, VisitorData } from "../../types/visitTypes";
import "./AddVisit.css";
import { DocumentTypeInfo, GenderInfo, ShipInfo } from "../../types/visitTypes";

const SubmitVisit = (props: {
  stepNextFunction: any;
  stepBackFunction: any;
  shipId: number | null;
  ships: ShipInfo[];
  startdate: Date | null;
  enddate: Date | null;
  portName: string | null;
  visitors: VisitorData[];
  documentType: DocumentTypeInfo[];
  gender: GenderInfo[];
  nationality: NationalityInfo[];
  addVisitFailed: boolean;
  apiCallInProgess: boolean;
}) => {
  return (
    <>
      <div className="add-visit-step-3">
        <Row>
          <Col span={18} offset={3}>
            <Card>
              <h2 className="add-visit-text">
                Ship:{" "}
                {props.shipId != null
                  ? props.ships.find((ship) => ship.Id === props.shipId)?.Name
                  : "-"}
              </h2>
              <h2 className="add-visit-text">
                Date:{" "}
                {props.startdate != null && props.enddate != null
                  ? props.startdate?.toLocaleDateString() +
                    " - " +
                    props.enddate?.toLocaleDateString()
                  : "-"}
              </h2>
              <h2 className="add-visit-text">
                Port: {props.portName != null ? props.portName : "-"}
              </h2>
            </Card>
            <h2>Visitors:</h2>

            {props.visitors.map((visitor) => (
              <Card>
                <Row>
                  <Col
                    className="add-visit-summary-group"
                    xs={24}
                    sm={24}
                    md={24}
                    lg={24}
                    xl={16}
                    xxl={16}
                  >
                    <Row>
                      <Col xs={24} sm={24} md={24} lg={6} xl={6} xxl={6}>
                        <span className="add-visit-summary-text">
                          First name:
                        </span>
                        <br />
                        <b className="add-visit-summary-text-value">
                          {visitor.Forename.length > 0 ? visitor.Forename : "-"}
                        </b>
                      </Col>
                      <Col xs={24} sm={24} md={24} lg={6} xl={6} xxl={6}>
                        <span className="add-visit-summary-text">Last name:</span>
                        <br />
                        <b className="add-visit-summary-text-value">
                          {visitor.Surname.length > 0 ? visitor.Surname : "-"}
                        </b>
                      </Col>
                      <Col xs={24} sm={24} md={24} lg={6} xl={6} xxl={6}>
                        <span className="add-visit-summary-text">
                          Birth date:
                        </span>
                        <br />
                        {visitor.BirthDate != null
                          ? visitor.BirthDate.toLocaleDateString()
                          : "-"}
                      </Col>
                    </Row>
                    <Row>
                      <Col xs={24} sm={24} md={24} lg={6} xl={6} xxl={6}>
                        <span className="add-visit-summary-text">Address:</span>
                        <br />
                        <p className="add-visit-summary-text-value">
                          {visitor.Address.length > 0 ? visitor.Address : "-"}
                        </p>
                      </Col>
                      <Col xs={24} sm={24} md={24} lg={6} xl={6} xxl={6}>
                        <span className="add-visit-summary-text">City:</span>
                        <br />
                        <p className="add-visit-summary-text-value">
                          {visitor.City.length > 0 ? visitor.City : "-"}
                        </p>
                      </Col>
                      <Col xs={24} sm={24} md={24} lg={6} xl={6} xxl={6}>
                        <span className="add-visit-summary-text">Gender:</span>
                        <br />
                        {visitor.Gender.length > 0
                          ? props.gender.find(
                              (type) => type.Key === visitor.Gender
                            )?.Value
                          : "-"}
                      </Col>
                    </Row>
                    <Row>
                      <Col xs={24} sm={24} md={24} lg={6} xl={6} xxl={6}>
                        <span className="add-visit-summary-text">Phone:</span>
                        <br />{" "}
                        <p className="add-visit-summary-text-value">
                          {visitor.Phone.length > 0 ? visitor.Phone : "-"}
                        </p>
                      </Col>
                      <Col xs={24} sm={24} md={24} lg={6} xl={6} xxl={6}>
                        <span className="add-visit-summary-text">Email:</span>
                        <br />
                        <p className="add-visit-summary-text-value">
                          {visitor.Email.length > 0 ? visitor.Email : "-"}
                        </p>
                      </Col>
                      <Col xs={24} sm={24} md={24} lg={6} xl={6} xxl={6}>
                        <span className="add-visit-summary-text">License plate:</span>
                        <br />
                        <p className="add-visit-summary-text-value">
                          {visitor.LicensePlate.length > 0 ? visitor.LicensePlate : "-"}
                        </p>
                      </Col>
                    </Row>
                    <Row>
                      <Col xs={24} sm={24} md={24} lg={6} xl={6} xxl={6}>
                        <span className="add-visit-summary-text">
                          Nationality:
                        </span>
                        <br />
                        {(visitor.Nationality && visitor.Nationality.length > 0)
                          ? props.nationality.find(
                              (type) => type.Code === visitor.Nationality
                            )?.Name
                          : "-"}
                      </Col>
                      <Col xs={24} sm={24} md={24} lg={6} xl={6} xxl={6}>
                        <span className="add-visit-summary-text">Company name:</span>
                        <br />
                        <p className="add-visit-summary-text-value">
                          {visitor.TravelerComments.length > 0
                            ? visitor.TravelerComments
                            : "-"}
                        </p>
                      </Col>
                      <Col xs={24} sm={24} md={24} lg={6} xl={6} xxl={6}>
                        <span className="add-visit-summary-text">Function:</span>
                        <br />
                        <p className="add-visit-summary-text-value">
                          {visitor.VisitorFunction.length > 0 ? visitor.VisitorFunction : "-"}
                        </p>
                      </Col>
                    </Row>
                    <Row>
                      <Col xs={24} sm={24} md={24} lg={6} xl={6} xxl={6}>
                        <span className="add-visit-summary-text">Contact on board:</span>
                        <br />
                        <p className="add-visit-summary-text-value">
                          {visitor.ContactPerson.length > 0 ? visitor.ContactPerson : "-"}
                        </p>
                      </Col>
                    </Row>
                  </Col>
                  <Col
                    className="add-visit-summary-group"
                    xs={24}
                    sm={24}
                    md={24}
                    lg={24}
                    xl={8}
                    xxl={8}
                  >
                    <Row>
                      <Col xs={24} sm={24} md={24} lg={6} xl={12} xxl={12}>
                        <span className="add-visit-summary-text">
                          Document type:
                        </span>
                        <br />
                        {visitor.DocumentType.length > 0
                          ? props.documentType.find(
                              (type) => type.Key === visitor.DocumentType
                            )?.Value
                          : "-"}
                      </Col>
                      <Col xs={24} sm={24} md={24} lg={6} xl={12} xxl={12}>
                        <span className="add-visit-summary-text">
                          Document number:
                        </span>
                        <br />
                        <p className="add-visit-summary-text-value">
                          {visitor.DocumentNumber.length > 0
                            ? visitor.DocumentNumber
                            : "-"}
                        </p>
                      </Col>
                    </Row>
                    <Row>
                      <Col xs={24} sm={24} md={24} lg={6} xl={12} xxl={12}>
                        <span
                          word-wrap="break-word"
                          className="add-visit-summary-text"
                        >
                          First name:
                        </span>
                        <br />
                        <p className="add-visit-summary-text-value">
                          {visitor.DocumentForename.length > 0
                            ? visitor.DocumentForename
                            : "-"}
                        </p>
                      </Col>
                      <Col xs={24} sm={24} md={24} lg={6} xl={12} xxl={12}>
                        <span
                          word-wrap="break-word"
                          className="add-visit-summary-text"
                        >
                          Last name:
                        </span>
                        <br />
                        <p className="add-visit-summary-text-value">
                          {visitor.DocumentSurname.length > 0
                            ? visitor.DocumentSurname
                            : "-"}
                        </p>
                      </Col>
                    </Row>
                    <Row>
                      <Col xs={24} sm={24} md={24} lg={6} xl={12} xxl={12}>
                        <span className="add-visit-summary-text">Place:</span>
                        <br />
                        <p className="add-visit-summary-text-value">
                          {visitor.DocumentAddress.length > 0
                            ? visitor.DocumentAddress
                            : "-"}
                        </p>
                      </Col>
                      <Col xs={24} sm={24} md={24} lg={6} xl={12} xxl={12}>
                        <span className="add-visit-summary-text">
                          Valid date:
                        </span>
                        <br />
                        {visitor.DocumentValidDate != null
                          ? visitor.DocumentValidDate.getMonth() + 1
                          : null}
                        /{visitor.DocumentValidDate?.getFullYear()}
                      </Col>
                    </Row>
                  </Col>
                </Row>
              </Card>
            ))}
            <div className="add-visit-message">
              {props.addVisitFailed ? (
                <Alert message="Add Visit Failed!" type="error" />
              ) : null}
            </div>
            <div className="add-visit-submit">
              <Space direction="horizontal">
                <Button onClick={props.stepBackFunction}>Back</Button>
                <Button
                  loading={props.apiCallInProgess}
                  onClick={props.stepNextFunction}
                >
                  {props.apiCallInProgess ? "" : "Submit"}
                </Button>
              </Space>
            </div>
          </Col>
        </Row>
      </div>
    </>
  );
};

export default SubmitVisit;
